import { useEffect } from 'react'

function LandingPage() {
  // Tema siempre claro - sin opción de cambio
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('dark');
    localStorage.setItem('theme', 'light');
  }, []);
  
  return (
    <div>
      <div className="min-h-screen bg-white text-slate-900">
        {/* Top Banner */}
        <div className="bg-gradient-to-r from-indigo-600 to-sky-500 text-white py-2">
          <div className="max-w-6xl mx-auto px-4 text-center text-sm">
            <span>🎉 <strong>Nuevo:</strong> Alertas inteligentes y presupuestos automáticos</span>
          </div>
        </div>
        {/* Nav */}
        <header className="sticky top-0 z-30 backdrop-blur supports-[backdrop-filter]:bg-white/60 dark:supports-[backdrop-filter]:bg-slate-900/60 border-b border-slate-200 dark:border-slate-800">
          <div className="mx-auto max-w-6xl px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <img 
                src="/logo.png" 
                alt="SUSCRI.net" 
                className="h-10 w-auto"
              />
            </div>
            <nav className="hidden md:flex items-center gap-6 text-sm">
              <a href="#benefits" className="hover:text-indigo-600 dark:hover:text-indigo-400">Beneficios</a>
              <a href="#demo" className="hover:text-indigo-600 dark:hover:text-indigo-400">Demo</a>
              <a href="#usecases" className="hover:text-indigo-600 dark:hover:text-indigo-400">Casos de uso</a>
              <a href="#testimonials" className="hover:text-indigo-600 dark:hover:text-indigo-400">Opiniones</a>
            </nav>
            <div className="flex items-center gap-2">
              <a href="/login" className="inline-flex items-center gap-2 rounded-xl bg-indigo-600 text-white px-4 py-2 text-sm font-semibold shadow-sm hover:bg-indigo-500">
                Empieza gratis
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" /></svg>
              </a>
            </div>
          </div>
        </header>

        {/* Hero */}
        <section className="relative overflow-hidden">
          <div className="mx-auto max-w-6xl px-4 py-20 grid md:grid-cols-2 gap-10 items-center">
            <div>
              <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight leading-tight">
                Controla todas tus <span className="bg-gradient-to-tr from-indigo-600 to-sky-500 bg-clip-text text-transparent">suscripciones</span>.
              </h1>
              <p className="mt-5 text-lg text-slate-600 dark:text-slate-300 max-w-prose">
                Ahorra dinero y gana tranquilidad con alertas antes de cada cobro, un panel claro y presupuestos inteligentes.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <a href="/login" className="inline-flex items-center justify-center gap-2 rounded-2xl bg-indigo-600 text-white px-6 py-3 text-base font-semibold shadow-sm hover:bg-indigo-500">
                  Crear mi cuenta gratuita
                  <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" /></svg>
                </a>
                <a href="#demo" className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 dark:border-slate-800 px-6 py-3 text-base font-medium hover:bg-slate-50 dark:hover:bg-slate-900">
                  Ver demo rápida
                </a>
              </div>
              <p className="mt-3 text-sm text-slate-500 dark:text-slate-400">Sin tarjeta. Sin complicaciones.</p>
            </div>
            <div className="relative">
              <div className="rounded-3xl border border-slate-200 dark:border-slate-800 shadow-xl p-4 bg-white dark:bg-slate-950">
                {/* Mockup simple */}
                <div className="flex items-center justify-between border-b border-slate-200 dark:border-slate-800 pb-3">
                  <div className="h-3 w-3 rounded-full bg-slate-200" />
                  <div className="h-3 w-3 rounded-full bg-slate-200" />
                  <div className="h-3 w-3 rounded-full bg-slate-200" />
                </div>
                <div className="grid grid-cols-3 gap-4 mt-4">
                  <div className="col-span-3 rounded-2xl bg-slate-50 dark:bg-slate-900 p-4">
                    <div className="text-sm text-slate-500">Gasto mensual</div>
                    <div className="text-3xl font-bold mt-1">€ 132,40</div>
                  </div>
                  {["Netflix","Spotify","Figma","AWS","Prime","Adobe"].map((name, i) => (
                    <div key={i} className="rounded-2xl bg-slate-50 dark:bg-slate-900 p-4">
                      <div className="text-sm font-semibold">{name}</div>
                      <div className="text-xs text-slate-500">Renueva en {3+i} días</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="absolute -bottom-6 -left-6 h-24 w-24 rounded-full bg-indigo-500/20 blur-2xl"/>
              <div className="absolute -top-6 -right-6 h-24 w-24 rounded-full bg-sky-400/20 blur-2xl"/>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="mx-auto max-w-6xl px-4 py-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="bg-slate-50 dark:bg-slate-900/50 rounded-2xl p-6">
              <div className="text-3xl font-bold text-indigo-600">€245</div>
              <div className="text-sm text-slate-600 dark:text-slate-300">Ahorro promedio mensual</div>
            </div>
            <div className="bg-slate-50 dark:bg-slate-900/50 rounded-2xl p-6">
              <div className="text-3xl font-bold text-indigo-600">12</div>
              <div className="text-sm text-slate-600 dark:text-slate-300">Suscripciones gestionadas</div>
            </div>
            <div className="bg-slate-50 dark:bg-slate-900/50 rounded-2xl p-6">
              <div className="text-3xl font-bold text-indigo-600">95%</div>
              <div className="text-sm text-slate-600 dark:text-slate-300">Usuarios satisfechos</div>
            </div>
          </div>
        </section>

        {/* Problem / Solution */}
        <section className="mx-auto max-w-6xl px-4 py-16 grid md:grid-cols-2 gap-10 items-start">
          <div>
            <h2 className="text-2xl font-bold">¿Cuántas suscripciones estás pagando sin saberlo?</h2>
            <p className="mt-4 text-slate-600 dark:text-slate-300">Entre plataformas, software y servicios, los cargos se acumulan. Nuestra plataforma te da claridad total: qué pagas, cuándo y cómo optimizarlo. Sin hojas de cálculo. Sin sorpresas.</p>
            <div className="mt-6 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4">
              <div className="text-sm text-red-800 dark:text-red-200">
                <strong>Dato alarmante:</strong> El usuario promedio paga €45/mes en suscripciones que no usa.
              </div>
            </div>
          </div>
          <ul className="space-y-3">
            {[
              {icon: "🔔", title: "Alertas antes de cada cobro", desc: "Evita renovaciones que no quieres."},
              {icon: "📊", title: "Panel claro", desc: "Gasto mensual y próximas renovaciones de un vistazo."},
              {icon: "💳", title: "Presupuestos inteligentes", desc: "Define límites y recibe avisos al acercarte."},
              {icon: "📄", title: "Facturas organizadas", desc: "Ten tu historial siempre a mano."},
              {icon: "📅", title: "Calendario de renovaciones", desc: "Visualiza tus próximos cargos."},
            ].map(({icon, title, desc}, i) => (
              <li key={i} className="flex gap-4">
                <div className="h-10 w-10 rounded-xl bg-indigo-600/10 text-indigo-600 dark:text-indigo-400 flex items-center justify-center">
                  <span className="text-lg">{icon}</span>
                </div>
                <div>
                  <div className="font-semibold">{title}</div>
                  <div className="text-sm text-slate-600 dark:text-slate-300">{desc}</div>
                </div>
              </li>
            ))}
          </ul>
        </section>

        {/* Benefits */}
        <section id="benefits" className="bg-slate-50 dark:bg-slate-900/50">
          <div className="mx-auto max-w-6xl px-4 py-16">
            <h2 className="text-2xl font-bold">Todo lo que necesitas para tener el control</h2>
            <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                { title: "Alertas automáticas", desc: "Recibe avisos antes de cada renovación o cobro." },
                { title: "Panel de control claro", desc: "Ve tus gastos mensuales de un vistazo." },
                { title: "Presupuestos inteligentes", desc: "Define límites y evita sorpresas." },
                { title: "Calendario de renovaciones", desc: "Planifica tus próximos pagos." },
                { title: "Gestión de facturas", desc: "Guarda y busca recibos fácilmente." },
              ].map((b, i) => (
                <div key={i} className="rounded-2xl border border-slate-200 dark:border-slate-800 p-6 bg-white/50 dark:bg-slate-950/50">
                  <div className="h-5 w-5 text-green-500 mb-3">✓</div>
                  <div className="mt-3 font-semibold">{b.title}</div>
                  <div className="text-sm text-slate-600 dark:text-slate-300">{b.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Demo */}
        <section id="demo" className="mx-auto max-w-6xl px-4 py-16">
          <div className="grid md:grid-cols-2 gap-10 items-center">
            <div>
              <h2 className="text-2xl font-bold">Tu nueva forma de gestionar el dinero digital</h2>
              <p className="mt-4 text-slate-600 dark:text-slate-300">Una interfaz limpia y moderna pensada para facilitarte la vida. Entras, revisas y sigues con tu día.</p>
              <a href="/login" className="mt-6 inline-flex items-center gap-2 rounded-2xl bg-slate-900 text-white dark:bg-white dark:text-slate-900 px-5 py-3 text-sm font-semibold hover:opacity-90">Crear mi cuenta</a>
            </div>
            <div className="rounded-3xl border border-slate-200 dark:border-slate-800 shadow-xl p-4 bg-white dark:bg-slate-950">
              <div className="h-56 rounded-2xl bg-gradient-to-br from-indigo-600/20 to-sky-400/20 grid place-items-center text-sm text-slate-500">
                Demo visual — coloca aquí capturas reales del dashboard, calendario y alertas
              </div>
            </div>
          </div>
        </section>

        {/* Use cases */}
        <section id="usecases" className="bg-slate-50 dark:bg-slate-900/50">
          <div className="mx-auto max-w-6xl px-4 py-16">
            <h2 className="text-2xl font-bold">Ideal para ti, seas quien seas</h2>
            <div className="mt-8 grid md:grid-cols-3 gap-6">
              {[
                {title: "Familias", desc: "Controla Netflix, Spotify, Amazon Prime y más."},
                {title: "Freelancers", desc: "Centraliza Figma, Adobe, hosting y herramientas SaaS."},
                {title: "Pymes", desc: "Organiza licencias y reduce costes en decenas de servicios."},
              ].map((c, i) => (
                <div key={i} className="rounded-2xl border border-slate-200 dark:border-slate-800 p-6 bg-white/50 dark:bg-slate-950/50">
                  <div className="font-semibold">{c.title}</div>
                  <div className="text-sm text-slate-600 dark:text-slate-300 mt-2">{c.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section id="testimonials" className="mx-auto max-w-6xl px-4 py-16">
          <h2 className="text-2xl font-bold">Lo que dicen nuestros usuarios</h2>
          <div className="mt-8 grid md:grid-cols-3 gap-6">
            {[
              {quote: "Por fin sé cuánto gasto cada mes en servicios digitales. Ahorré más de 30 € el primer mes.", name: "Laura M.", role: "Diseñadora freelance", rating: 5},
              {quote: "Evité un cobro anual que ya no usaba. Vale cada minuto.", name: "Pedro R.", role: "Responsable IT en Pyme", rating: 5},
              {quote: "La interfaz es súper intuitiva. Mis hijos también la usan para sus suscripciones.", name: "María S.", role: "Madre de familia", rating: 5},
            ].map((t, i) => (
              <figure key={i} className="rounded-2xl border border-slate-200 dark:border-slate-800 p-6 bg-white/50 dark:bg-slate-950/50">
                <div className="flex mb-3">
                  {[...Array(t.rating)].map((_, j) => (
                    <svg key={j} className="h-4 w-4 text-yellow-400 fill-current" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <blockquote className="text-slate-700 dark:text-slate-200">"{t.quote}"</blockquote>
                <figcaption className="mt-3 text-sm text-slate-500">— {t.name}, {t.role}</figcaption>
              </figure>
            ))}
          </div>
        </section>

        {/* Pricing */}
        <section className="bg-slate-50 dark:bg-slate-900/50">
          <div className="mx-auto max-w-6xl px-4 py-16">
            <h2 className="text-2xl font-bold text-center">Planes simples y transparentes</h2>
            <div className="mt-8 grid md:grid-cols-3 gap-6">
              {[
                {name: "Gratis", price: "€0", period: "para siempre", features: ["Hasta 5 suscripciones", "Alertas básicas", "Panel simple"], popular: false},
                {name: "Pro", price: "€4.99", period: "al mes", features: ["Suscripciones ilimitadas", "Alertas inteligentes", "Presupuestos automáticos", "Soporte prioritario"], popular: true},
                {name: "Familiar", price: "€9.99", period: "al mes", features: ["Todo de Pro", "Hasta 6 usuarios", "Gestión familiar", "Reportes avanzados"], popular: false},
              ].map((plan, i) => (
                <div key={i} className={`rounded-2xl border p-6 ${plan.popular ? 'border-indigo-500 bg-indigo-50 dark:bg-indigo-900/20' : 'border-slate-200 dark:border-slate-800'} bg-white/50 dark:bg-slate-950/50`}>
                  {plan.popular && (
                    <div className="bg-indigo-600 text-white text-xs font-semibold px-3 py-1 rounded-full inline-block mb-4">
                      Más popular
                    </div>
                  )}
                  <div className="font-semibold text-lg">{plan.name}</div>
                  <div className="text-3xl font-bold mt-2">{plan.price}</div>
                  <div className="text-sm text-slate-500">{plan.period}</div>
                  <ul className="mt-4 space-y-2">
                    {plan.features.map((feature, j) => (
                      <li key={j} className="flex items-center text-sm">
                        <svg className="h-4 w-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <button className={`w-full mt-6 py-2 px-4 rounded-lg font-medium ${plan.popular ? 'bg-indigo-600 text-white hover:bg-indigo-700' : 'bg-slate-100 dark:bg-slate-800 text-slate-900 dark:text-slate-100 hover:bg-slate-200 dark:hover:bg-slate-700'}`}>
                    {plan.name === "Gratis" ? "Empezar gratis" : "Elegir plan"}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="mx-auto max-w-6xl px-4 py-16">
          <h2 className="text-2xl font-bold text-center">Preguntas frecuentes</h2>
          <div className="mt-8 space-y-4">
            {[
              {q: "¿Es seguro conectar mis cuentas bancarias?", a: "Sí, usamos encriptación de grado bancario y nunca almacenamos tus credenciales. Solo leemos los movimientos para identificar suscripciones."},
              {q: "¿Puedo cancelar en cualquier momento?", a: "Absolutamente. No hay compromisos a largo plazo. Puedes cancelar tu suscripción en cualquier momento desde tu cuenta."},
              {q: "¿Funciona con todas las suscripciones?", a: "Sí, detectamos automáticamente suscripciones de Netflix, Spotify, Amazon Prime, servicios SaaS, y muchos más."},
              {q: "¿Hay límite en el plan gratuito?", a: "El plan gratuito incluye hasta 5 suscripciones y alertas básicas. Perfecto para empezar."},
            ].map((faq, i) => (
              <div key={i} className="border border-slate-200 dark:border-slate-800 rounded-lg p-4">
                <div className="font-semibold text-slate-900 dark:text-slate-100">{faq.q}</div>
                <div className="text-sm text-slate-600 dark:text-slate-300 mt-2">{faq.a}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Final CTA */}
        <section className="bg-gradient-to-br from-indigo-600 to-sky-500">
          <div className="mx-auto max-w-6xl px-4 py-16 text-white text-center">
            <h2 className="text-3xl font-bold">Empieza hoy a controlar tus suscripciones</h2>
            <p className="mt-2 opacity-90">Regístrate gratis y descubre lo fácil que es tener claridad total sobre tus gastos.</p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
              <a href="/login" className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white text-slate-900 px-6 py-3 text-base font-semibold hover:opacity-90">
                Crear mi cuenta gratuita
              </a>
              <a href="#demo" className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white/10 backdrop-blur px-6 py-3 text-base font-semibold hover:bg-white/20">
                Ver cómo funciona
              </a>
            </div>
            <p className="mt-3 text-sm text-white/80">Sin tarjeta. Cancelación en 1 clic.</p>
          </div>
        </section>

        {/* Footer */}
        <footer className="border-t border-slate-200 dark:border-slate-800">
          <div className="mx-auto max-w-6xl px-4 py-10 grid md:grid-cols-2 gap-6 items-center">
            <div className="text-sm text-slate-500 dark:text-slate-400">© {new Date().getFullYear()} Suscripto — Todos los derechos reservados.</div>
            <div className="flex gap-6 text-sm justify-start md:justify-end">
              <a href="#" className="hover:underline">FAQ</a>
              <a href="#" className="hover:underline">Seguridad</a>
              <a href="#" className="hover:underline">Privacidad</a>
              <a href="#" className="hover:underline">Contacto</a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default LandingPage
